import { render } from "./DistributionOfTransfersPerBankChart.vue?vue&type=template&id=76842499"
import script from "./DistributionOfTransfersPerBankChart.vue?vue&type=script&lang=js"
export * from "./DistributionOfTransfersPerBankChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__